module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "wrapper"
  }, [_vm._c('PageHeader', {
    attrs: {
      "title": _vm.chapter ? ("Study " + (_vm.chapter.title)) : 'Loading...'
    }
  }, [_vm._c('ol', {
    staticClass: "breadcrumb pull-left",
    staticStyle: {
      "margin-top": "0"
    }
  }, [_vm._c('li', [_vm._c('router-link', {
    attrs: {
      "to": {
        name: 'subject-shelf'
      }
    }
  }, [_vm._c('i', {
    staticClass: "icon mdi mdi-arrow-left"
  }), _vm._v("  Home")])], 1)]), _vm._v(" "), (_vm.microNotes && _vm.microNotes.length) ? _vm._c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._c('KeywordSettings', {
    staticClass: "pull-right",
    attrs: {
      "chapterId": _vm.chapter.chapter_id
    }
  }), _vm._v(" "), _vm._c('div', {
    staticClass: "email-filters-right  text-right pull-right xs-mr-10"
  }, [_vm._c('span', {
    staticClass: "email-pagination-indicator"
  }, [_vm._v(_vm._s(_vm.microNotes.length) + " remaining ")]), _vm._v(" "), _vm._c('div', {
    staticClass: "btn-group email-pagination-nav"
  }, [_vm._c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.previousMicroNote($event)
      }
    }
  }, [_vm._c('i', {
    staticClass: "mdi mdi-chevron-left"
  })]), _vm._v(" "), _vm._c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.nextMicroNote($event)
      }
    }
  }, [_vm._c('i', {
    staticClass: "mdi mdi-chevron-right"
  })])])])], 1) : _vm._e(), _vm._v(" "), _vm._c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _vm._c('div', {
    staticClass: "chapterStudier main-content container-fluid"
  }, [_vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-md-12"
  }, [_vm._c('Panel', {
    staticClass: "panel panel-default"
  }, [(!_vm.chapter || !_vm.microNotes) ? _vm._c('PanelBody', [_vm._c('LoadingIndicator')], 1) : (!_vm.chapter.micro_notes_count) ? _vm._c('PanelBody', [_vm._c('div', {
    staticClass: "sm-mt-20 alert alert-primary alert-icon alert-icon-border",
    attrs: {
      "role": "alert"
    }
  }, [_vm._c('div', {
    staticClass: "icon"
  }, [_vm._c('span', {
    staticClass: "mdi mdi-info-outline"
  })]), _vm._v(" "), _vm._c('div', {
    staticClass: "message"
  }, [_vm._c('strong', [_vm._v("Empty!")]), _vm._v(" This chapter has no micro notes.\n              ")])])]) : (!_vm.microNotes.length) ? _vm._c('PanelBody', [_vm._c('div', {
    staticClass: "sm-mt-20 alert alert-success alert-icon alert-icon-border",
    attrs: {
      "role": "alert"
    }
  }, [_vm._c('div', {
    staticClass: "icon"
  }, [_vm._c('span', {
    staticClass: "mdi mdi-info-outline"
  })]), _vm._v(" "), _vm._c('div', {
    staticClass: "message"
  }, [_vm._c('strong', [_vm._v("Good!")]), _vm._v(" You've finished studying the micro notes in this chapter.\n              ")])]), _vm._v(" "), _vm._c('p', [_vm._c('img', {
    attrs: {
      "src": _vm.successImageUrl
    }
  })])]) : _vm._c('div', [(_vm.microNote && _vm.microNote.micro_note_type === 'image') ? _vm._c('MicroNoteImageStudier', {
    attrs: {
      "microNote": _vm.microNote
    }
  }) : _vm._c('MicroNoteStudier', {
    attrs: {
      "microNote": _vm.microNote
    }
  }), _vm._v(" "), _vm._c('BottomShelf', {
    attrs: {
      "microNote": _vm.microNote,
      "chapter": _vm.chapter
    }
  })], 1)], 1)], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6fdc83db!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter-studier/ChapterStudier.vue
// module id = 681
// module chunks = 1